// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"04336d09","977":"23b1d813"}[chunkId] + ".chunk.js";
};